import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";
// import { useAuth } from "../context/auth";
// import { OverlayTrigger, Tooltip } from "react-bootstrap";

export const footerAll = {
  english: {
    termText: `Terms of use`,
    helpText: `Help`,
    followText: `Follow us`,
    privacyText: `Privacy`,
    cookiesText: `Cookies`,
  },
  italiano: {
    termText: `Termini e Condizioni`,
    helpText: `Supporto`,
    followText: `Seguici`,
    privacyText: `Privacy`,
    cookiesText: `Cookie`,
  },
  deutsch: {
    termText: `AGB`,
    helpText: `Support`,
    followText: `Folge uns`,
    privacyText: `Datenschutz`,
    cookiesText: `Cookies`,
  },
  español: {
    termText: `Términos y condiciones`,
    helpText: `Soporte`,
    followText: `Síguenos`,
    privacyText: `Privacidad`,
    cookiesText: `Cookies`,
  },
  francais: {
    termText: `Conditions générales`,
    helpText: `Support`,
    followText: `Suivez-nous`,
    privacyText: `Confidentialité`,
    cookiesText: `Cookies`,
  },
  nihongo: {
    termText: `利用規約`,
    helpText: `サポート`,
    followText: `フォローする`,
    privacyText: `プライバシー`,
    cookiesText: `クッキー`,
  },
  nederlands: {
    termText: `Gebruiksvoorwaarden`,
    helpText: `Hulp`,
    followText: `Volg ons`,
    privacyText: `Privacy`,
    cookiesText: `Cookies`,
  },
  chinese: {
    termText: `使用条款`,
    helpText: `帮助`,
    followText: `关注我们`,
    privacyText: `隐私`,
    cookiesText: `Cookie`,
  },
};
const Footer2 = () => {
  // const [auth] = useAuth();
  const { selectedLanguage } = useContext(LanguageContext);

  return (
    <>
      <div
        className="foterh py-10"
        style={{ backgroundColor: "#34C3C9",  }}
      >
        <div className="d-flex mx-sm-5 mx-3  justify-content-between ">
          <div className="d-flex  justify-content-center gap-md-4 mt-md-2 p-md-4  padtopfoter2">
            <Link
              to="/terms"
              className="text-decoration-none fw-normal fontmobil"
              style={{
                color: "#FFFFFF",

                lineHeight: "24.51px",
                fontSize: "16px",
              }}
            >
              {/* Terms of use */}
              {footerAll[selectedLanguage]?.termText}
            </Link>
            <Link
              to="/privacy"
              className="text-decoration-none fw-normal fontmobil"
              style={{
                color: "#FFFFFF",

                lineHeight: "24.51px",
                fontSize: "16px",
              }}
            >
              {footerAll[selectedLanguage]?.privacyText || "Privacy"}
            </Link>
            <Link
              to="/cookies"
              className="text-decoration-none fw-normal fontmobil"
              style={{
                color: "#FFFFFF",

                lineHeight: "24.51px",
                fontSize: "16px",
              }}
            >
              {footerAll[selectedLanguage]?.cookiesText || "Cookies"}
            </Link>

            <Link
              to="/help"
              className="text-decoration-none text-white fw-normal fontmobil"
              style={{
                lineHeight: "24.51px",
                fontSize: "16px",
              }}
            >
              {/* Help */}
              {footerAll[selectedLanguage]?.helpText}
            </Link>

            {/* <div>
              {auth?.user ? (
                <Link
                  to="/help"
                  className="text-decoration-none text-white fw-bold fontmobil"
                  style={{
                    lineHeight: "24.51px",
                    fontSize: "18px",
                  }}
                >
                  Help
                </Link>
              ) : (
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id="tooltip-login">Please login first</Tooltip>
                  }
                >
                  <span
                    className="text-decoration-none text-white fw-bold fontmobil"
                    style={{
                      lineHeight: "24.51px",
                      fontSize: "18px",
                      cursor: "pointer",
                    }}
                  >
                    Help
                  </span>
                </OverlayTrigger>
              )}
            </div> */}
          </div>

          <div className="mt-md-4 mt-4  mx-md-5 ">
            <div
              className="fw-bold text-center ftzcopy"
              style={{
                lineHeight: "35.85px",
                fontSize: "16px",
                color: "#FFFFFF",
              }}
            >
              {/* Follow us */}
              {footerAll[selectedLanguage]?.followText}
            </div>
            <div className="d-flex justify-content-center gap-md-2 gap-1 mt-md-1 ">
              <a
                href="https://www.facebook.com/profile.php?id=61582380255125"
                target="blank"
              >
                <img
                  src={require("../pages/image/fbhome.png")}
                  style={{ cursor: "pointer" }}
                  width="32"
                  height="32"
                />
              </a>
              <a href="https://www.tiktok.com/@ofellio" target="blank">
                <img
                  src={require("../pages/image/tiktokhome.png")}
                  style={{ cursor: "pointer" }}
                  width="32"
                  height="32"
                />
              </a>
              <a
                href="https://www.instagram.com/ofellio_official/"
                target="blank"
              >
                <img
                  src={require("../pages/image/instahome.png")}
                  style={{ cursor: "pointer" }}
                  width="32"
                  height="32"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer2;
